export default __webpack_public_path__ + "static/a06e8dac-2517-4ee0-8e76-00b63d2a6fa7-2db0aacd3ecabd28b31aaf00cf3e4fd7.woff";